module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('../node_modules/gatsby-theme-affiliate/gatsby-browser.js'),
      options: {"plugins":[],"app":{"name":"Eksempel.no"},"theme":{"colors":{"primary":"green","primaryHover":"green","secondary":"lightgreen","secondaryHover":"light-green"}}},
    }]
